import { Drawer } from '@mui/material';
import React from 'react';
import { BsFillMoonFill, BsFillSunFill } from 'react-icons/bs';
import { FaTools, FaUser } from 'react-icons/fa';
import { HiBriefcase, HiDocumentText } from 'react-icons/hi';
import { IoClose, IoHomeSharp, IoMenuSharp } from 'react-icons/io5';
import { MdOutlineCloudQueue, MdPhone } from 'react-icons/md';
import { RiRocket2Fill } from 'react-icons/ri';
import Fade from '../../../utils/Fade';
import { HashLink as NavLink } from 'react-router-hash-link';
import { headerData } from '../../../data/headerData';
import './navbar.css';

function NavbarUI({ theme, shortname, classes, handleDrawerOpen, handleDrawerClose, open, changeTheme, isDark }) {
  return (
    <div className='navbar'>
      <div className='navbar--container'>
        <h1 style={{ color: theme.primary }}>{shortname(headerData.name)}</h1>

        <IoMenuSharp
          className={classes.navMenu}
          onClick={handleDrawerOpen}
          aria-label='Menu'
        />
      </div>
      <Drawer
        variant='temporary'
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleDrawerClose();
          } else if (reason !== 'escapeKeyDown') {
            handleDrawerClose();
          }
        }}
        anchor='left'
        open={open}
        classes={{ paper: classes.MuiDrawer }}
        className='drawer'
        disableScrollLock={true}
      >
        <div className='div-closebtn'>
          <IoClose
            onClick={handleDrawerClose}
            onKeyDown={(e) => {
              if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                handleDrawerClose();
              }
            }}
            className={classes.closebtnIcon}
            role='button'
            tabIndex='0'
            aria-label='Close'
          />
        </div>
        <br />

        <div onClick={handleDrawerClose}>
          <div className='navLink--container'>
            <Fade left>
              <NavLink to='/' smooth={true} spy='true' duration={2000}>
                <div className={classes.drawerItem}>
                  <IoHomeSharp className={classes.drawerIcon} />
                  <span className={classes.drawerLinks}>Home</span>
                </div>
              </NavLink>
            </Fade>

            <Fade left>
              <NavLink to='/#about' smooth={true} spy='true' duration={2000}>
                <div className={classes.drawerItem}>
                  <FaUser className={classes.drawerIcon} />
                  <span className={classes.drawerLinks}>About</span>
                </div>
              </NavLink>
            </Fade>

            <Fade left>
              <NavLink to='/#projects' smooth={true} spy='true' duration={2000}>
                <div className={classes.drawerItem}>
                  <RiRocket2Fill className={classes.drawerIcon} />
                  <span className={classes.drawerLinks}>Projects</span>
                </div>
              </NavLink>
            </Fade>

            <Fade left>
              <NavLink to='/#skills' smooth={true} spy='true' duration={2000}>
                <div className={classes.drawerItem}>
                  <FaTools className={classes.drawerIcon} />
                  <span className={classes.drawerLinks}>Skills</span>
                </div>
              </NavLink>
            </Fade>

            <Fade left>
              <NavLink to='/#experience' smooth={true} spy='true' duration={2000}>
                <div className={classes.drawerItem}>
                  <HiBriefcase className={classes.drawerIcon} />
                  <span className={classes.drawerLinks}>Approach</span>
                </div>
              </NavLink>
            </Fade>


            <Fade left>
              <NavLink to='/#infrastructure' smooth={true} spy='true' duration={2000}>
                <div className={classes.drawerItem}>
                  <MdOutlineCloudQueue className={classes.drawerIcon} />
                  <span className={classes.drawerLinks}>Infra</span>
                </div>
              </NavLink>
            </Fade>

            <Fade left>
              <NavLink to='/#education' smooth={true} spy='true' duration={2000}>
                <div className={classes.drawerItem}>
                  <HiDocumentText className={classes.drawerIcon} />
                  <span className={classes.drawerLinks}>Education</span>
                </div>
              </NavLink>
            </Fade>

            <Fade left>
              <div className={classes.drawerItem} onClick={changeTheme}>
                {isDark ? (
                  <BsFillSunFill className={classes.drawerIcon} />
                ) : (
                  <BsFillMoonFill className={classes.drawerIcon} />
                )}
                <span className={classes.drawerLinks}>{isDark ? 'Light' : 'Dark'}</span>
              </div>
            </Fade>

            <Fade left>
              <NavLink to='/#contacts' smooth={true} spy='true' duration={2000}>
                <div className={classes.drawerItem}>
                  <MdPhone className={classes.drawerIcon} />
                  <span className={classes.drawerLinks}>Contact</span>
                </div>
              </NavLink>
            </Fade>
          </div>
        </div>
      </Drawer>
    </div>
  );
}

export default NavbarUI;
